import { IDictionary } from '@/shared/models/interface/dictionary-model'
import { FilterItem } from '../models/filter-viewmodel'
import { ISearchResult } from '../models/search-model'

export interface IDictionaryMapper {
    mapSearchResults(response: ISearchResult[]): IDictionary<string>
    mapFilterItems(response: FilterItem[]): IDictionary<string>
}

class DictionaryMapper implements IDictionaryMapper {
    public mapSearchResults(response: ISearchResult[]): IDictionary<string> {
        return Object.assign(
            {},
            ...response.map((x: ISearchResult) => ({
                [x.Id]: x.Title
            }))
        )
    }

    public mapFilterItems(response: FilterItem[]): IDictionary<string> {
        return Object.assign(
            {},
            ...response.map((x: FilterItem) => ({
                [x.CodeName]: x.DisplayName
            }))
        )
    }
}

export default new DictionaryMapper()